"use client";
import useMobileNav from "@/app/hooks/useMobileNav";
import MobileNav from "./MobileNav";

const MobileNavWrapper = () => {
  const { isOpen, onClose } = useMobileNav();
  return <MobileNav isOpen={isOpen} onClose={onClose} />;
};

export default MobileNavWrapper;